// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__k1CQ6","dots":"Pagination_dots__I0H8y"};